import { useEffect, useRef } from 'react';
import { BACKEND_URL } from '@/config/api';

/*
  Ficha firmada para los formularios públicos (registro, contacto, test de idoneidad). backend/antibot.py.
  Se pide al abrir el formulario y el servidor solo acepta el envío a partir de 3 s y hasta 2 h después.
  useFormToken() devuelve una función async que entrega una ficha válida: si no hay o tiene más de 100 min,
  pide otra, y si se envía antes de 3 s, espera lo que falte (una persona nunca nota la espera).
*/
const FORM_MIN_MS = 3200;
const MAX_AGE_MS = 100 * 60 * 1000;
const sleep = (ms) => new Promise((r) => { setTimeout(r, ms); });

async function loadFormToken(ref) {
  try {
    const r = await fetch(`${BACKEND_URL}/api/form-token`);
    if (r.ok) ref.current = { token: (await r.json()).form_token, at: Date.now() };
  } catch { /* sin conexión: el envío avisará */ }
}

export function useFormToken() {
  const ref = useRef({ token: null, at: 0 });
  useEffect(() => { loadFormToken(ref); }, []);
  return async () => {
    if (!ref.current.token || Date.now() - ref.current.at > MAX_AGE_MS) await loadFormToken(ref);
    const wait = FORM_MIN_MS - (Date.now() - ref.current.at);
    if (wait > 0) await sleep(wait);
    return ref.current.token;
  };
}

// Campo trampa: invisible para las personas y fuera del tabulador; solo lo rellena un bot.
export const honeypotStyle = { position: 'absolute', left: '-10000px', width: 1, height: 1, overflow: 'hidden' };
